import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import RobotPersonalIcon from '@images/owner/ic_robot_personal.svg';
import RobotOnlineIcon from '@images/owner/ic_robot_online.svg';
import RobotOfflineIcon from '@images/owner/ic_robot_offline.svg';
import { BOT_STATUS_TYPE } from '@utils/types';

const statusIconMap = {
  [BOT_STATUS_TYPE.OFFLINE]: RobotOfflineIcon,
  [BOT_STATUS_TYPE.UNAVAILABLE]: RobotOnlineIcon,
  [BOT_STATUS_TYPE.ONLINE]: RobotOnlineIcon,
  [BOT_STATUS_TYPE.MISSION_READY]: RobotOnlineIcon,
  [BOT_STATUS_TYPE.PERSONAL_READY]: RobotPersonalIcon,
  [BOT_STATUS_TYPE.MISSION_IN_PROGRESS]: RobotOfflineIcon,
};

export default function BotStatusIcon({ status, className }) {
  const icon = statusIconMap[status] || RobotOfflineIcon;

  return (
    <Tooltip title={`Bot is ${status}`} placement="top">
      <img className={className} src={icon} alt="robot-status" />
    </Tooltip>
  );
}